module.exports = __webpack_public_path__ + "img/default-noimgProduct2.6b204623.png";